/**
 * Restrictions for the bio field in the bot builder
 * Limits formatting options to only those that are supported in the renderer
 */

export const bioDisabledExtensions = [
  "file",
  "image",
  "embeds",
  "poll",
  "cta",
  "ai_copilot",
  "horizontal_rule",
  "code_block",
  "mention",
  "entities",
  "headings",
];

export const bioDisabledSlashMenuCategories = ["Upload", "Embed"];

export const bioDisabledSlashMenuCommands = [
  "h1",
  "h2",
  "h3",
  "block-quote",
  "divider",
  "code",
  "mention",
  "cta",
  "poll",
  "image",
  "file",
  "audio",
  "video",
  "pdf",
];

/**
 * Combined editor restrictions object for use with spread operator
 */
export const bioEditorRestrictions = {
  disabledExtensions: bioDisabledExtensions,
  disabledSlashMenuCategories: bioDisabledSlashMenuCategories,
  disabledSlashMenuCommands: bioDisabledSlashMenuCommands,
  showListsInTextModifierMenu: false,
  headingLevels: [],
};
